// Generated by purs version 0.14.3
"use strict";
var App_Component_AssetTransfer = require("../App.Component.AssetTransfer/index.js");
var App_Model = require("../App.Model/index.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Data_Void = require("../Data.Void/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_HTML = require("../Halogen.HTML/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Type_Proxy = require("../Type.Proxy/index.js");
var AssetTransferSlot = function (x) {
    return x;
};
var AddAssetTransfer = (function () {
    function AddAssetTransfer(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    AddAssetTransfer.create = function (value0) {
        return function (value1) {
            return new AddAssetTransfer(value0, value1);
        };
    };
    return AddAssetTransfer;
})();
var InitialAction = (function () {
    function InitialAction() {

    };
    InitialAction.value = new InitialAction();
    return InitialAction;
})();
var eqAssetTransferSlot = new Data_Eq.Eq(function (x) {
    return function (y) {
        return x === y;
    };
});
var ordAssetTransferSlot = new Data_Ord.Ord(function () {
    return eqAssetTransferSlot;
}, function (x) {
    return function (y) {
        return Data_Ord.compare(Data_Ord.ordInt)(x)(y);
    };
});
var addTransfer = function (at) {
    return function (st) {
        var newTransfer = {
            transferId: st.nextId,
            transfer: at
        };
        return {
            transfers: Data_Array.take(20)(Data_Array.cons(newTransfer)(st.transfers)),
            nextId: st.nextId + 1 | 0
        };
    };
};
var _srHeader = Type_Proxy["Proxy"].value;
var srList = function (dictMonadAff) {
    var renderTransfer = function (t) {
        return Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
            return "srHeader";
        }))(ordAssetTransferSlot)(_srHeader)(t.transferId)(App_Component_AssetTransfer.assetTransfer(dictMonadAff)(t.transfer))(Data_Unit.unit)(Data_Void.absurd);
    };
    var render = function (st) {
        return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("sr-container") ])([ Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("sr-list") ])([ Halogen_HTML_Elements.ul_(Data_Functor.map(Data_Functor.functorArray)(renderTransfer)(st.transfers)) ]) ]);
    };
    var handleQuery = function (v) {
        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify(Halogen_Query_HalogenM.monadStateHalogenM)(addTransfer(v.value0)))(function () {
            return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(new Data_Maybe.Just(v.value1));
        });
    };
    var $$eval = Halogen_Component.mkEval({
        handleAction: Halogen_Component.defaultEval.handleAction,
        handleQuery: handleQuery,
        receive: Halogen_Component.defaultEval.receive,
        initialize: Halogen_Component.defaultEval.initialize,
        finalize: Halogen_Component.defaultEval.finalize
    });
    return Halogen_Component.mkComponent({
        initialState: Data_Function["const"](App_Model.initialList),
        render: render,
        "eval": $$eval
    });
};
module.exports = {
    AddAssetTransfer: AddAssetTransfer,
    InitialAction: InitialAction,
    AssetTransferSlot: AssetTransferSlot,
    "_srHeader": _srHeader,
    srList: srList,
    addTransfer: addTransfer,
    eqAssetTransferSlot: eqAssetTransferSlot,
    ordAssetTransferSlot: ordAssetTransferSlot
};
